export default __webpack_public_path__ + "static/jwatkins-f34b9fb75e7f9d64305eed73d827e0f2.jpg";